// extracted by mini-css-extract-plugin
export var selected = "Tabs-module--selected--0fSHO";
export var tab = "Tabs-module--tab--k2gZP";
export var tabs = "Tabs-module--tabs--1wzP6";